module.exports = __webpack_public_path__ + "static/media/union-group.62885948.svg";